export const getPaymentUrl = (url: string = '', trafficSoure: string = '') => {
  return trafficSoure ? `${url}&traffic_soure=${trafficSoure}` : url
}
